module.exports = __webpack_public_path__ + "img/8quanjqr.5dc3ad8d.png";